import { gql } from "@codesandbox/api";
import type { Editor } from "features/types/editor";
import { hasSandboxPermission } from "isomorphic/permission";

export const canSeamlessBranch = (editor: Editor) => {
  if (editor.type === "sandbox") {
    return (
      !editor.restricted &&
      (editor.isFrozen ||
        !hasSandboxPermission(editor.authorization, "write_code"))
    );
  }

  const isWriteUserOnProtectedBranch =
    editor.protectedBranch &&
    (editor.authorization === gql.ProjectAuthorization.WRITE ||
      editor.authorization === gql.ProjectAuthorization.ADMIN);
  // As read user you can create a contribution branch from any branch really
  const isReadUser =
    editor.authorization === gql.ProjectAuthorization.READ &&
    // We do not want seamless branching to trigger on READ ONLY branches where
    // you have write access. This is because we prioritise the user to take an action to
    // import the repo as opposed to creating a contribution branch
    (editor.repoPermission === gql.GithubPermission.READ ||
      editor.repoPermission === gql.GithubPermission.NONE);

  return isWriteUserOnProtectedBranch || isReadUser;
};
